class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.productSlider = document.querySelector('product-slider');
    this.featuredMedia = null;

    this.addEventListener('change', this.onVariantChange);
    this.onVariantChange();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      // this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    // looking for presale data to use in toggleAddButton function
    this.options_presale_date = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input'))
        .find((radio) => radio.checked)
        .getAttribute('data-presale-date');
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media?.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        if (this.featured_media?.id !== this.currentVariant?.featured_media.id) {
          this.featured_media = this.currentVariant?.featured_media;
          const galleryId = `product-gallery-${this.dataset.section}`;
          const galleryDestination = document.getElementById(galleryId);
          const gallerySource = html.getElementById(galleryId);

          if (gallerySource && galleryDestination)
            galleryDestination.innerHTML = gallerySource.innerHTML;
        }

        const details_destination = document.getElementById('product_toggle_details');
        const material_destination = document.getElementById('product_toggle_material');
        const metafields_destination = document.getElementById('variant-metafields-container');
        const shownherewith_destination = document.getElementById('shown-here-with-container');
        const shopthelook_destination = document.getElementById('shop-the-look');
        const limited_edition_destination = document.getElementById('limited-edition-badge');
        const qtyproduced_destination = document.getElementById('qty-produced');
        const productnotice_destination = document.getElementById('product-notice');
        const variant_notice_destination = document.getElementById('product-variant-notice');

        const details_source = html.getElementById('product_toggle_details');
        const material_source = html.getElementById('product_toggle_material');
        const metafields_source = html.getElementById('variant-metafields-container');
        const shownherewith_source = html.getElementById('shown-here-with-container');
        const shopthelook_source = html.getElementById('shop-the-look');
        const limited_edition_source = html.getElementById('limited-edition-badge');
        const qtyproduced_source = html.getElementById('qty-produced');
        const productnotice_source = html.getElementById('product-notice');
        const variant_notice_source = html.getElementById('product-variant-notice');

        if (details_destination && details_source)
          details_destination.innerHTML = details_source.innerHTML;

        if (material_destination && material_source)
          material_destination.innerHTML = material_source.innerHTML;

        if (metafields_destination && metafields_source)
          metafields_destination.innerHTML = metafields_source.innerHTML;

        if (shownherewith_destination && shownherewith_source)
          shownherewith_destination.innerHTML = shownherewith_source.innerHTML;
        
        if (shopthelook_destination && shopthelook_source)
          shopthelook_destination.innerHTML = shopthelook_source.innerHTML;

        if (limited_edition_destination && limited_edition_source)
          limited_edition_destination.innerHTML = limited_edition_source.innerHTML;

        if (qtyproduced_destination && qtyproduced_source)
          qtyproduced_destination.innerHTML = qtyproduced_source.innerHTML;

        if (productnotice_destination && productnotice_source)
          productnotice_destination.innerHTML = productnotice_source.innerHTML;

        if (variant_notice_destination && variant_notice_source){
          variant_notice_destination.innerHTML = variant_notice_source.innerHTML;
        }

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        this.updateColorLabel();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    const presale_date = this.options_presale_date.toString().replace(/,/g, '');

    if (presale_date) {
      // variant is presale
      addButton.removeAttribute('disabled');
      addButton.textContent = 'PRE-ORDER';
      var preorder_html =
        '<div id="presale-attributes"><input type="hidden" class="line-item-property-input" data-name="pre_order" name="properties[pre_order]" value="yes" /><input type="hidden" class="line-item-property-input" data-name="start_date" name="properties[start_date]" value="' +
        presale_date +
        '"/><div class="presale-note">This item is estimated to ship on ' +
        presale_date +
        '.</div></div>';
      if (!document.contains(document.getElementById('presale-attributes'))) {
        document
          .getElementById('product-form-actions')
          .insertAdjacentHTML('afterend', preorder_html);
      }
    } else {
      // variant is NOT presale
      if (document.contains(document.getElementById('presale-attributes'))) {
        document.getElementById('presale-attributes').remove();
        if (disable) {
          addButton.setAttribute('disabled', true);
          if (text) addButton.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButton.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateColorLabel() {
    const inputs = this.getElementsByClassName('product-form__input');
    for (const input of inputs) {
      const position = input.dataset.optionPosition;
      const inputLabel = input.querySelector('.form__label span');
      if (inputLabel && position) {
        inputLabel.innerHTML = this.currentVariant[`option${position}`];
      }
    }
  }
}

customElements.define('variant-radios', VariantRadios);
